<template>
  <div>
    <Subheader title="Contact us" />

    <div class="app-content-column">
      <div class="card">
        <h5>Contacts</h5>
        <p>Mzingo Development Ltd., 417-40400, Amicus Plaza, Suna-Migori, Kenya</p>
        <p><a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a></p>
      </div>

      <div id="feedback-form" class="card">
        <h5>Send your feedback</h5>

        <form class="form" @submit.stop.prevent="submitFeedback">
          <FormError v-if="showFormErrors" :form-errors="formErrors" />

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="name">
            <input
              id="visitor-name"
              v-model="feedback.name"
              type="text"
              placeholder="Name"
              autocomplete="given-name"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="email">
            <input
              v-model="feedback.email"
              type="email"
              autocomplete="email"
              placeholder="Email"
              required
            />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="phone">
            <vue-tel-input
              v-model="feedback.phone"
              wrapper-classes="tel-input"
              placeholder="Mobile Phone"
              mode="international"
              :max-len="20"
              :valid-characters-only="true"
              :required="true"
            ></vue-tel-input>
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="subject">
            <input v-model="feedback.subject" type="text" placeholder="Subject" required />
          </Field>

          <Field :errors="fieldErrors" :show-field-errors="showFieldErrors" name="message">
            <textarea
              v-model="feedback.message"
              placeholder="Type your message here..."
              class="textarea"
              rows="6"
              maxlength="300"
              required
            />
          </Field>

          <div class="button-wrapper is-centered">
            <button type="submit" class="large-button" :disabled="loading">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/*global fbq*/
import { VueTelInput } from 'vue-tel-input'

import Subheader from '@/components/Subheader'
import Field from '@/components/Field'
import FormError from '@/components/FormError'

import Feedback from '@/services/feedbacks'

import { validateInputLength, validatePhoneInput } from '@/services/forms'

export default {
  name: 'Contacts',
  components: {
    VueTelInput,
    Subheader,
    Field,
    FormError,
  },
  data() {
    return {
      feedback: Feedback.create(),
      loading: false,
      // field errors are from client-side validation
      fieldErrors: [],
      showFieldErrors: false,
      // form errors are from server-side validation
      formErrors: [],
      showFormErrors: false,
    }
  },
  mounted() {
    this.feedback.subject = this.$route.query.subject || ''
  },
  methods: {
    /* Post feedback */
    async submitFeedback() {
      // Facebook Pixel tracking code
      fbq('track', 'SendFeedback')

      this.loading = true
      this.fieldErrors = this.collectFieldErrors()

      if (this.fieldErrors.length) {
        this.showFieldErrors = true
        let element = document.getElementById('visitor-name')
        element.scrollIntoView({ behavior: 'smooth' })
      } else {
        try {
          await Feedback.api.create({
            email: this.feedback.email,
            name: this.feedback.name,
            phone: this.feedback.phone,
            subject: this.feedback.subject,
            message: this.feedback.message,
          })
        } catch (error) {
          const { response } = error
          if (response && response.data) {
            this.formErrors = response.data
            this.showFormErrors = true
          }
          this.loading = false
          return
        }
      }
      this.loading = false
    },
    collectFieldErrors() {
      const errors = []

      Object.keys(this.feedback).forEach(field => {
        const error = validateInputLength(field, this.feedback[field])
        if (error) {
          errors.push(error)
        }
      })

      const error = validatePhoneInput('phone', this.feedback.phone)
      if (error) {
        errors.push(error)
      }

      return errors
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/layout';
@import '../styles/forms';

.card {
  @include card-w-borders();

  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  border: none;
}
</style>
